import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createLexiconConceptApiLexiconConceptsPost, type CreateLexiconConceptRequest } from "@noa/api-core";
import { reportError } from "../../typed-client";
import { ApiError } from "../../errors";
import { LexiconQueryKey } from "../../query-keys";

const postLexicalConcept = async (concept: CreateLexiconConceptRequest) => {
  const { data } = await createLexiconConceptApiLexiconConceptsPost({
    body: concept,
    throwOnError: true,
  });
  return data;
};

export const useCreateLexiconConcept = () => {
  const queryClient = useQueryClient();
  return useMutation<Awaited<ReturnType<typeof postLexicalConcept>>, ApiError, CreateLexiconConceptRequest>({
    mutationFn: postLexicalConcept,
    onError: reportError,
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({ queryKey: [...LexiconQueryKey.all, "subjects"] });
      const affectedSubjects = new Set([variables.subject_fr, variables.subject_en].filter((s): s is string => !!s));
      affectedSubjects.forEach((subject) => {
        void queryClient.invalidateQueries({ queryKey: LexiconQueryKey.conceptsBySubject(subject) });
      });
    },
  });
};
